import { WMSTileLayer } from "react-leaflet";
import { Z } from "../../global/constants/zIndex";
import { useActiveRasterTypename } from "../../hooks/useActiveRasterTypename";

interface TiledWMSLayerProps {
  typename: string;
  workspace: string;
  styles?: string;
  sldBody?: string;
  zIndex?: number;
  opacity?: number;
  detailedLayerName?: string;
  detailedLayerZoomThreshold?: number;
}

const GEOSERVER_URL = "https://geoserver-atlas.isitics.com/geoserver";

export function TiledWMSLayer({
  typename,
  workspace,
  styles,
  sldBody,
  zIndex = Z.MAP_LAYER_DEFAULT,
  opacity = 0.8,
  detailedLayerName,
  detailedLayerZoomThreshold = 12,
}: TiledWMSLayerProps) {
  const activeTypename = useActiveRasterTypename(
    typename,
    detailedLayerName,
    detailedLayerZoomThreshold
  );

  return (
    <WMSTileLayer
      // key forces react-leaflet to swap the underlying Leaflet layer instead of
      // mutating it in place, since WMSTileLayer/TileLayer don't diff `layers` reliably
      key={`${activeTypename}|${styles ?? ""}|${sldBody ?? ""}`}
      url={`${GEOSERVER_URL}/${workspace}/wms`}
      layers={`${workspace}:${activeTypename}`}
      {...(styles !== undefined ? { styles } : {})}
      {...(sldBody !== undefined ? { sld_body: sldBody } : {})}
      format="image/png"
      transparent={true}
      version="1.1.0"
      {...(sldBody === undefined ? ({ tiled: true } as object) : {})}
      opacity={opacity}
      zIndex={zIndex}
    />
  );
}
